// box-control.component.ts
import { Component, Input } from '@angular/core';
import { Treatment } from 'app/core/classes/treatment';
import { AusIntraArticularAdditionalInfoA, AusIntraArticularAdditionalInfoB } from 'app/core/types/intra-articular-info-types';

@Component({
  selector: 'app-intra-articular-additional-info',
  templateUrl: './intra-articular-additional-info.component.html',
})
export class IntraArticularAdditionalInfo {
  @Input() intraArticularAdditionalInfo: string[];
  @Input() treatment: Treatment;
  @Input() treatmentForm: any;

  public ausIntraArticularAdditionalInfosA = [
    AusIntraArticularAdditionalInfoA.right_fore,
    AusIntraArticularAdditionalInfoA.left_Fore,
    AusIntraArticularAdditionalInfoA.right_hind,
    AusIntraArticularAdditionalInfoA.left_hind,
    AusIntraArticularAdditionalInfoA.rf_lf,
    AusIntraArticularAdditionalInfoA.rh_lh
  ]

  public ausIntraArticularAdditionalInfosB = [
    AusIntraArticularAdditionalInfoB.coffin_joint,
    AusIntraArticularAdditionalInfoB.pastern_joint,
    AusIntraArticularAdditionalInfoB.fetlock_joint,
    AusIntraArticularAdditionalInfoB.knee,
    AusIntraArticularAdditionalInfoB.hock
  ]

  onInfoTypeClick(infoType: string) {
    this.treatment.intra_articular_infoA = infoType;
  }

  getActiveInfo(type: string) {
    if (type == "limb") {
      if (this.treatment.intra_articular_infoA) {
        var selectedItem = [{
          id: this.treatment.intra_articular_infoA,
          text: this.treatment.intra_articular_infoA
        }]
        return selectedItem;
      }
      return []
    } else if (type == "joint") {
      if (this.treatment.intra_articular_infoB) {
        var selectedItem = [{
          id: this.treatment.intra_articular_infoB,
          text: this.treatment.intra_articular_infoB
        }]
        return selectedItem;
      }
      return []
    }
  }

  setIntraInfo(e: any, type: string) {
    if (type == "limb") {
      this.treatment.intra_articular_infoA = e.id;
    } else if (type == "joint") {
      this.treatment.intra_articular_infoB = e.id;
    }

    console.log(this.treatment);

  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/intraArticularAdditionalInfo.component.ts